interface StaticPageProps {
	title: string
	children?: React.ReactNode
}

export function StaticPage({ title, children }: StaticPageProps): React.JSX.Element {
	return (
		<div className="mx-auto max-w-3xl px-4 py-12">
			<h1 className="mb-6 text-3xl font-bold">{title}</h1>
			<div className="prose space-y-4 text-muted-foreground">{children ?? <p>Contenido en preparación.</p>}</div>
		</div>
	)
}
